import { FC } from 'react';
import { SearchInput } from '@new/common/ui/SearchInput/SearchInput';
import { useCourseListContext } from '@new/common/contexts/CourseListContext';

export const CourseSearchBar: FC = () => {
  const { searchQuery, setSearchQuery } = useCourseListContext();

  return (
    <SearchInput value={searchQuery} onChange={setSearchQuery} placeholder="Search courses..." />
  );
};
